// import {decryptString} from 'string-crypto';
import StringCrypto from 'string-crypto'

const ANSWER = 'e4af6a763601a6e475a5c26ec1b5e82b:51635a6b49384643786a4270434c6354472b30496a306f7a57686e416b626b73354e4959565733564547346f6462474245534333544c7930386c2b786651694948446134616132374a6e505777734977385a3169784474596a396665614e4c634d34537679726f52386768354d636d6950437561417533696b69363531756b424c70714d563458594546704f2b78722f4a6c703459734e334339326e643939594951453d';
const ENCRYPTED_CIPHER = `c02ed2d59a24790e3761c3f5a3b6719d:61774a7357716b4b677a5137634c4f7265716272706d704c576948313879455968457746383764417868313779787242796861447879766e5a4879334d765853344d4e656368415a514e4750784755423730472b32687830624d512f505565557a6a6668626f5749376b4d49723353593541386f7631524d587a7a50497175676d506b696b365a6f726951684b643454334d396e707573473946592b6d2f536e344c6a4c326b544d506968424656614951494a436d414d636f2f556e63736957476348493633416551613438577270526c7330694272496c6b2f515542324d724e4a334d745050476c54687069536830324361774c33555163463447425a70483973314d6977756b6367794747747076794a2b752f42506c645a31762f72304656486c597763744b794f376c7139496c546b4b37585056656c515a2f4e77345268302b4f41336934673954744a4c306d486138472f584a49506551787543777837355467716847543149446353736a4b423157656259447033392b306a377669332b6442494c7265326d44504f6f4141526d667144352f36554b61715035325644537350474f5361416473626255744d31336f573449473832456a3473726f4d6f77786a486b4d6b446b737068366136353159444a777269734365314d74722f69513d3d`

const options = {
  salt: '2f0ijf2039j23r09j2fg45o9ng98um4o',
  iterations: 10,
  digest: 'sha512',
};

const { decryptString} = new StringCrypto(options);

const tryPassword = (password) => {
    if( decryptString(ENCRYPTED_CIPHER, password) === ANSWER){
        console.log('correct password!')
        return true
      }else{
          console.log('wrong password') 
          return false
      }
}

export {
    tryPassword
}